import { TextField, SelectField } from "@/components/form";
import { formatPhone, formatEin, formatSsn } from "@/utils/format";
import { StepHeading, useZipAutoFill, OWNERSHIP_TYPES, isSoleProprietor } from "@/features/onboarding/components/wizard";
import { STATE_OPTIONS } from "@/utils/states";
import { type StepProps } from "./schema";

export function LegalStep({ form }: StepProps) {

  useZipAutoFill(form.watch("zip"), (st, ci) => {
    const sv = { shouldValidate: form.formState.isSubmitted };
    if (st) form.setValue("state", st, sv);
    if (ci) form.setValue("city", ci, sv);
  });
  const ownershipType = form.watch("ownershipType");
  const c = form.control;

  return (
    <div className="space-y-5">
      <StepHeading title="Legal information" />

      <TextField control={c} name="legalName" label="Corporate / Legal Name" required placeholder="Acme Coffee Co." />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextField control={c} name="email" label="Email" required inputMode="email" placeholder="you@business.com" />
        <TextField control={c} name="phone" label="Business phone" required type="tel" inputMode="tel" maxLength={14} placeholder="(555) 123-4567" format={formatPhone} />
      </div>

      <TextField control={c} name="addressLine1" label="Business address" required placeholder="123 Main St" />

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        <TextField control={c} name="zip" label="ZIP" required inputMode="numeric" maxLength={5} placeholder="94103" format={(v) => v.replace(/\D/g, "").slice(0, 5)} />
        <SelectField control={c} name="state" label="State" required placeholder="Select" options={STATE_OPTIONS} />
        <TextField control={c} name="city" label="City" required placeholder="San Francisco" className="col-span-2 sm:col-span-1" />
      </div>

      <SelectField control={c} name="ownershipType" label="Ownership type" required placeholder="Select" options={OWNERSHIP_TYPES.map((t) => [t, t])} />

      {isSoleProprietor(ownershipType) ? (
        <TextField control={c} name="ssn" label="Social Security Number (SSN)" required inputMode="numeric" maxLength={11} placeholder="XXX-XX-XXXX" format={formatSsn} hint="Sole proprietors provide an SSN. 9 digits, formatted as XXX-XX-XXXX." />
      ) : (
        <TextField control={c} name="ein" label="Employer Identification Number (EIN)" required inputMode="numeric" maxLength={10} placeholder="XX-XXXXXXX" format={formatEin} hint="9 digits, formatted as XX-XXXXXXX" />
      )}
    </div>
  );
}
